
import u from "umbrellajs"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"


import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"


const load_content = (building_id: string) => {
  return q_ajax_3({
    url:      Routes.single_commercial_building_summary_page__below_the_fold_page_content_path({
      locale: I18n.locale,
      building_id: building_id,
    }),
    type:     "GET",
    dataType: "html",
  })
}

const load_and_inject_content = (building_id: string) => {
  const $container = u("#page-section--below-the-fold")
  if ($container.length === 0) { return Promise.resolve() }

  return load_content(building_id)
  .then(({data}) => {
    $container.html(data)
  })
}

const load_content_and_inject_later = (building_id: string) => {
  const $container = u("#page-section--below-the-fold")
  if ($container.length === 0) { return Promise.resolve(() => { /* Do nothing */ }) }

  return load_content(building_id)
  .then(({data}) => {
    return () => {
      $container.html(data)
    }
  })
}

export {
  load_and_inject_content,
  load_content_and_inject_later,
}
